var _path, _circle, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.46 4.339a1.058 1.058 0 010-2.117h3.238c1.593 0 2.389.154 3.216.596a4.263 4.263 0 011.767 1.768c.443.827.597 1.623.597 3.216v3.239a1.058 1.058 0 11-2.117 0V7.802c0-1.274-.09-1.739-.346-2.218a2.147 2.147 0 00-.899-.9c-.479-.255-.944-.345-2.218-.345h-3.239zm6.701 24.62a1.058 1.058 0 012.117 0v3.239c0 1.593-.154 2.389-.596 3.216a4.263 4.263 0 01-1.768 1.768c-.828.442-1.623.596-3.216.596h-3.239a1.058 1.058 0 010-2.117h3.239c1.273 0 1.739-.09 2.218-.346.39-.209.69-.509.9-.899.255-.479.345-.944.345-2.218v-3.239zM12.6 36.72c0-.584-.474-1.058-1.059-1.058H8.303c-1.274 0-1.74-.09-2.218-.346a2.147 2.147 0 01-.9-.899c-.256-.479-.345-.944-.345-2.218v-3.239a1.058 1.058 0 00-2.117 0v3.239c0 1.593.154 2.389.596 3.216a4.263 4.263 0 001.768 1.768c.827.442 1.623.596 3.216.596h3.239c.584 0 1.058-.474 1.058-1.058zm-7.76-25.678a1.058 1.058 0 01-2.117 0V7.802c0-1.593.154-2.389.596-3.216a4.263 4.263 0 011.768-1.768c.827-.442 1.623-.596 3.216-.596h3.239a1.058 1.058 0 010 2.117H8.302c-1.274 0-1.74.09-2.218.346-.39.208-.69.509-.9.899-.256.479-.345.944-.345 2.218v3.239zm23.923-2.152H12.238c-.991 0-1.35.103-1.712.297a2.02 2.02 0 00-.84.84c-.194.362-.297.721-.297 1.712v1.595H31.61v-1.595c0-.99-.103-1.35-.297-1.712a2.019 2.019 0 00-.84-.84c-.362-.194-.721-.297-1.712-.297zm2.223 6.667h-20.97c-.99 0-1.35.103-1.712.296a2.019 2.019 0 00-.84.84c-.193.363-.296.722-.296 1.712v3.192c0 .99.103 1.35.296 1.712.194.362.478.646.84.84.363.193.722.296 1.712.296h20.97c.99 0 1.35-.103 1.711-.296.363-.194.647-.478.84-.84.194-.363.297-.722.297-1.712v-3.192c0-.99-.103-1.35-.297-1.712a2.019 2.019 0 00-.84-.84c-.362-.193-.72-.296-1.711-.296zM9.389 26.666H31.61v1.596c0 .99-.103 1.35-.297 1.712a2.019 2.019 0 01-.84.84c-.362.194-.721.297-1.712.297H12.238c-.991 0-1.35-.103-1.712-.297a2.02 2.02 0 01-.84-.84c-.194-.362-.297-.721-.297-1.712v-1.595z",
    fill: "#7B8B99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33,
    r: 9.778,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.722 33c0 5.4 4.378 9.778 9.778 9.778S43.278 38.4 43.278 33 38.9 23.222 33.5 23.222 23.722 27.6 23.722 33zm10.787-6.111h-2.018c-.283-.003-.515.184-.519.417v.023l.465 7.108c.017.225.245.399.518.396h1.09c.273.003.5-.171.518-.396l.464-7.108c.012-.233-.207-.43-.49-.44h-.028zm-1.01 12.53a1.528 1.528 0 100-3.056 1.528 1.528 0 000 3.056z",
    fill: "url(#Preview_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Preview_svg__paint0_linear",
    x1: 23.722,
    y1: 23.222,
    x2: 23.722,
    y2: 42.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA000"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default ForwardRef;